import React, { useState, useEffect } from 'react';
import './EventFormModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';



const categorieTypeMap = {
  'A définir': ['A définir'],
  'Culturel et artistique': [
    'Théâtre',
    'Concert',
    'Danse',
    'Cinéma',
    'Exposition',
    'Festival',
    'Slam',
    'Projection de film',
    'Atelier',
    'Masterclass'
  ],
  'Social': [
    'Réunion',
    'Mariage',
    'Réception',
    'Salon',
    'Social'
  ],
  'Économique et commercial': [
    'Salon',
    'Réception',
    'Conférence',
    'Séminaire'
  ],
  'Politique': [
    'Débats d\'idées',
    'Réunion',
    'Conférence',
    'Séminaire'
  ],
  'Religieux': [
    'Religieux',
    'Projection de film',
    'Réunion'
  ]
};




const EventFormModal = ({
  isOpen,
  onClose,
  onAddEvent,
  onUpdateEvent,
  clickedDate,
  editMode,
  eventToEdit
}) => {
  const [form, setForm] = useState({
    nomPrenom: '',
    contact: '',
    titre: '',
    debutDate: '',
    debutHeure: '',
    finDate: '',
    finHeure: '',
    salle: [],
    categorie: '',
    type: '',
    couleur: '#000000',
    totalPayer: '',
    tranches: [''],
    note: '',
    agent: '',
    duree: ''
  });

  const [errors, setErrors] = useState({ duree: '' });
  const [salles, setSalles] = useState([]);
  const [agents, setAgents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [types, setTypes] = useState([]);

  // Fonction déplacée AVANT les useEffect
  const fetchSallesDisponibles = async (startDate, startTime, endDate, endTime) => {
    if (!startDate || !startTime || !endDate || !endTime) return;
  
    const debut = `${startDate}_${startTime}`;
    const fin = `${endDate}_${endTime}`;
    const eventIdToExclude = editMode && eventToEdit?.id ? `&exclude_event_id=${eventToEdit.id}` : '';
  
    try {


      const res = await fetch(`https://ccjab.pro/api/salles.php?disponibles=1&debut=${debut}&fin=${fin}${eventIdToExclude}`);

      const data = await res.json();
      setSalles(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Erreur lors de la vérification des salles disponibles :', err);
    }
  };
  

  useEffect(() => {
    if (!isOpen) return;

    fetchData();

    if (editMode && eventToEdit) {
      const debut = new Date(eventToEdit.start);
      const fin = new Date(eventToEdit.end);

      const debutDate = debut.toISOString().split('T')[0];
      const debutHeure = debut.toTimeString().substring(0, 5);
      const finDate = fin.toISOString().split('T')[0];
      const finHeure = fin.toTimeString().substring(0, 5);

      setForm({
        nomPrenom: eventToEdit.nom_prenom || '',
        contact: eventToEdit.contact || '',
        titre: eventToEdit.title || '',
        debutDate,
        debutHeure,
        finDate,
        finHeure,
        salle: eventToEdit.noms_salles || [],
        categorie: eventToEdit.categorie_nom || '',
        type: eventToEdit.type_nom || '',
        couleur: eventToEdit.couleur || '#000000',
        totalPayer: eventToEdit.total_payer || '',
        tranches: [
          String(eventToEdit.tranche_1 || ''),
          String(eventToEdit.tranche_2 || ''),
          String(eventToEdit.tranche_3 || '')
        ],
        note: eventToEdit.note || '',
        agent: eventToEdit.agent_nom || '',
        duree: ''
      });

      // 🔁 Recharge les salles selon les dates de l'évènement en modification
      fetchSallesDisponibles(debutDate, debutHeure, finDate, finHeure);
    }

    if (!editMode && clickedDate) {
      const date = new Date(clickedDate);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      const hh = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');

      setForm({
        nomPrenom: '',
        contact: '',
        titre: '',
        debutDate: `${yyyy}-${mm}-${dd}`,
        debutHeure: `${hh}:${min}`,
        finDate: '',
        finHeure: '',
        salle: [],
        categorie: '',
        type: '',
        couleur: '#000000',
        totalPayer: '',
        tranches: [''],
        note: '',
        agent: '',
        duree: ''
      });

      // Les salles seront rechargées automatiquement via l’autre useEffect
    }
  }, [isOpen, editMode, eventToEdit, clickedDate]);

  // ✅ Rechargement des salles disponibles quand les dates changent
  useEffect(() => {
    fetchSallesDisponibles(form.debutDate, form.debutHeure, form.finDate, form.finHeure);
  }, [form.debutDate, form.debutHeure, form.finDate, form.finHeure]);
  
  
  
  
  const fetchData = async () => {
    try {
      // 🔹 Salles
      const sallesRes = await fetch('https://ccjab.pro/api/salles.php');
      console.log("📡 Réponse salles status:", sallesRes.status);
      const sallesText = await sallesRes.text();
      console.log("📄 Contenu brut salles:", sallesText);
      const sallesJson = JSON.parse(sallesText);
      console.log("✅ Données salles:", sallesJson);
      setSalles(sallesJson);
  
      // 🔹 Agents
      const agentsRes = await fetch('https://ccjab.pro/api/agents.php');
      console.log("📡 Réponse agents status:", agentsRes.status);
      const agentsText = await agentsRes.text();
      console.log("📄 Contenu brut agents:", agentsText);
      const agentsJson = JSON.parse(agentsText);
      console.log("✅ Données agents:", agentsJson);
      setAgents(agentsJson);
  
      // 🔹 Catégories
      const categoriesRes = await fetch('https://ccjab.pro/api/categories.php');
      console.log("📡 Réponse catégories status:", categoriesRes.status);
      const categoriesText = await categoriesRes.text();
      console.log("📄 Contenu brut catégories:", categoriesText);
      const categoriesJson = JSON.parse(categoriesText);
      console.log("✅ Données catégories:", categoriesJson);
      setCategories(categoriesJson);
  
      // 🔹 Types
      const typesRes = await fetch('https://ccjab.pro/api/types.php');
      console.log("📡 Réponse types status:", typesRes.status);
      const typesText = await typesRes.text();
      console.log("📄 Contenu brut types:", typesText);
      const typesJson = JSON.parse(typesText);
      console.log("✅ Données types:", typesJson);
      setTypes(typesJson);
  
    } catch (err) {
      console.error("🚨 Une erreur est survenue:", err.message);
      console.error("🔍 Stack:", err.stack);
    }
  };
  
  


  useEffect(() => {
    if (form.debutDate && form.debutHeure && form.finDate && form.finHeure) {
      const start = new Date(`${form.debutDate}T${form.debutHeure}`);
      const end = new Date(`${form.finDate}T${form.finHeure}`);
      const diff = end - start;

      if (diff <= 0) {
        setForm((prev) => ({ ...prev, duree: '' }));
        setErrors((prev) => ({
          ...prev,
          duree: 'La date de début doit être antérieure à la date de fin.'
        }));
      } else {
        const minutes = Math.floor(diff / 60000);
        const days = Math.floor(minutes / 1440);
        const hours = Math.floor((minutes % 1440) / 60);
        const mins = minutes % 60;
        const parts = [];

        if (days > 0) parts.push(`${days} jour${days > 1 ? 's' : ''}`);
        if (hours > 0) parts.push(`${hours} heure${hours > 1 ? 's' : ''}`);
        if (mins > 0 || parts.length === 0) parts.push(`${mins} minute${mins > 1 ? 's' : ''}`);

        setForm((prev) => ({ ...prev, duree: parts.join(' ') }));
        setErrors((prev) => ({ ...prev, duree: '' }));
      }
    }
  }, [form.debutDate, form.debutHeure, form.finDate, form.finHeure]);

  useEffect(() => {
    fetchSallesDisponibles(form.debutDate, form.debutHeure, form.finDate, form.finHeure);
  }, [form.debutDate, form.debutHeure, form.finDate, form.finHeure]);
  

  useEffect(() => {
    // Réinitialiser la catégorie quand le type change
    setForm((prev) => ({ ...prev, categorie: '' }));
  }, [form.type]);
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSalleChange = (e) => {
    const { value, checked } = e.target;
    setForm((prev) => {
      const updatedSalles = checked
        ? [...prev.salle, value]
        : prev.salle.filter((s) => s !== value);
      return { ...prev, salle: updatedSalles };
    });
  };

  const handleTrancheChange = (index, value) => {
    if (/^\d*$/.test(value)) {
      const newTranches = [...form.tranches];
      newTranches[index] = value;
      setForm((prev) => ({ ...prev, tranches: newTranches }));
    }
  };

  const addTranche = () => {
    if (form.tranches.length < 3 && form.tranches[form.tranches.length - 1] !== '') {
      setForm((prev) => ({
        ...prev,
        tranches: [...prev.tranches, '']
      }));
    }
  };

  const removeTranche = (index) => {
    const updated = form.tranches.filter((_, i) => i !== index);
    setForm((prev) => ({ ...prev, tranches: updated }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const start = new Date(`${form.debutDate}T${form.debutHeure}`);
    const end = new Date(`${form.finDate}T${form.finHeure}`);
    const title = form.titre;

    if (!title || !start || !end) {
      toast.error("Veuillez remplir les champs obligatoires.");
      return;
    }

    if (!form.duree || errors.duree) {
      toast.error("La durée est invalide.");
      return;
    }

    const salleIds = salles
      .filter((s) => form.salle.includes(s.nom))
      .map((s) => s.id);

    const categorieObj = categories.find(c => c.nom_categorie === form.categorie);
    const typeObj = types.find(t => t.nom_type === form.type);
    const agentObj = agents.find(a => a.username === form.agent);

    const payload = {
      nomPrenom: form.nomPrenom,
      contact: form.contact,
      titre: form.titre,
      debutDate: form.debutDate,
      debutHeure: form.debutHeure,
      finDate: form.finDate,
      finHeure: form.finHeure,
      salle: salleIds,
      categorie: categorieObj?.id || null,
      type: typeObj?.id || null,
      couleur: form.couleur,
      totalPayer: form.totalPayer,
      tranches: form.tranches,
      note: form.note,
      agent: agentObj?.id || null
    };

    try {
      const user = JSON.parse(localStorage.getItem('user'));
      const userId = user?.id;

      const isEditing = editMode && eventToEdit?.id;
      const url = isEditing
        ? `https://ccjab.pro/api/evenements.php/${eventToEdit.id}`
        : 'https://ccjab.pro/api/evenements.php';

      const method = isEditing ? 'PUT' : 'POST';

      const res = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'x-user-id': userId
        },
        body: JSON.stringify(payload)
      });

      const data = await res.json();

      if (res.ok) {
        toast.success(data.message || (isEditing ? "Évènement modifié." : "Évènement ajouté."));
        const eventObj = { ...form, start, end, title };

        isEditing ? onUpdateEvent?.(eventObj) : onAddEvent?.(eventObj);
        onClose();
      } else {
        toast.error(data.message || "Erreur lors de l'enregistrement.");
      }
    } catch (error) {
      console.error("Erreur API:", error);
      toast.error("Erreur réseau !");
    }
  };

  const totalTranches = form.tranches.reduce((sum, val) => sum + Number(val || 0), 0);
  const totalPayer = Number(form.totalPayer || 0);
  const tranchesExcess = totalTranches > totalPayer && totalPayer > 0;

  if (!isOpen) return null;

  const filteredTypes = form.categorie
  ? types.filter(type =>
      (categorieTypeMap[form.categorie] || []).includes(type.nom_type)
    )
  : types;



  
  return (
    <div className="event-modal-overlay" onClick={(e) => e.target.classList.contains('event-modal-overlay') && onClose()}>
      <div className="event-modal">
        <button className="modal-close" onClick={onClose}>&times;</button>
        <h2>Créer un évènement</h2>
        <form onSubmit={handleSubmit}>
        
          <fieldset>
            <legend>Données du client</legend>
            <input name="nomPrenom" value={form.nomPrenom} onChange={handleChange} placeholder="Nom et prénom" />
            <input name="contact" value={form.contact} onChange={handleChange} placeholder="Contact" />
          </fieldset>

          

          <fieldset>
            <legend>Détails de l’évènement</legend>
            <label>Date et heure de début</label>
            <input name="titre" value={form.titre} onChange={handleChange} placeholder="Nom de l’évènement" />
            <div className="row">
              <input type="date" name="debutDate" value={form.debutDate} onChange={handleChange} />
              <input type="time" name="debutHeure" value={form.debutHeure} onChange={handleChange} />
            </div>
            <label>Date et heure de fin</label>
            <div className="row">
              <input type="date" name="finDate" value={form.finDate} onChange={handleChange} />
              <input type="time" name="finHeure" value={form.finHeure} onChange={handleChange} />
            </div>
            <input
              name="duree"
              value={form.duree}
              readOnly
              style={{
                backgroundColor: '#f1f1f1',
                cursor: 'not-allowed',
                borderColor: errors.duree ? 'red' : ''
              }}
            />
            {errors.duree && (
              <div style={{ color: 'red', fontSize: '0.85em' }}>{errors.duree}</div>
            )}
          </fieldset>

          <fieldset>
            <legend>Choix de la / des salle(s)</legend>
            <div className="checkbox-list">
              {salles.map((salle) => (
                <div key={salle.id} className="checkbox-item">
                  <input
                    type="checkbox"
                    value={salle.nom}
                    checked={form.salle.includes(salle.nom)}
                    onChange={handleSalleChange}
                    id={`salle-${salle.id}`}
                    disabled={salle.is_occupied === 1 && !form.salle.includes(salle.nom)}
                  />
                  <label htmlFor={`salle-${salle.id}`}>
                    {salle.nom} {salle.is_occupied === 1 && !form.salle.includes(salle.nom) ? ' (occupée)' : ''}
                  </label>
                </div>
              ))}
            </div>
          </fieldset>

          <fieldset>
            <legend>Catégorie</legend>
            <select
              name="categorie"
              value={form.categorie}
              onChange={handleChange}
            >
              <option value="">Sélectionner une catégorie</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.nom_categorie}>
                  {cat.nom_categorie}
                </option>
              ))}
            </select>
          </fieldset>

          <fieldset>
            <legend>Type d’évènement</legend>
            <select
              name="type"
              value={form.type}
              onChange={handleChange}
              disabled={!form.categorie}
            >
              <option value="">Sélectionner un type</option>
              {filteredTypes.map((type) => (
                <option key={type.id} value={type.nom_type}>
                  {type.nom_type}
                </option>
              ))}
            </select>
          </fieldset>



        
          <fieldset>
            <legend>Couleur</legend>
            <input
              type="color"
              name="couleur"
              value={form.couleur}
              onChange={handleChange}
              style={{
                width: '100%',
                height: '40px',
                border: 'none',
                padding: 0,
                cursor: 'pointer'
              }}
            />
          </fieldset>


          <fieldset>
            <legend>Paiement</legend>
            <input name="totalPayer" value={form.totalPayer} onChange={handleChange} placeholder="Total à payer" inputMode="numeric" />
            {form.tranches.map((val, index) => (
              <div key={index} className="tranche-row">
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={val}
                  onChange={(e) => handleTrancheChange(index, e.target.value)}
                  placeholder={`Montant tranche ${index + 1}`}
                />
                {form.tranches.length > 1 && (
                  <button type="button" className="delete-icon" onClick={() => removeTranche(index)}>
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </button>
                )}
              </div>
            ))}
            {form.tranches.length < 3 && form.tranches[form.tranches.length - 1] !== '' && (
              <button type="button" onClick={addTranche} className="add-tranche-btn">
                <FontAwesomeIcon icon={faPlusCircle} /> Ajouter une tranche
              </button>
            )}
            <p style={{ fontWeight: 'bold', marginTop: '10px' }}>
              Total tranches : {totalTranches} FCFA
            </p>
            {tranchesExcess && (
              <p style={{ color: 'red' }}>Le total des tranches dépasse le total à payer !</p>
            )}
          </fieldset>

          <fieldset>
            <legend>Autres informations</legend>
            <textarea
              name="note"
              value={form.note}
              onChange={handleChange}
              placeholder="Note"
              style={{ minHeight: '130px', resize: 'vertical' }}
            />
            <select name="agent" value={form.agent} onChange={handleChange}>
              <option value="">Sélectionner un agent</option>
              {agents.map((agent) => (
                <option key={agent.id} value={agent.username}>
                  {agent.username}
                </option>
              ))}
            </select>
          </fieldset>

          <div className="actions">
            <button type="button" className="cancel" onClick={onClose}>Annuler</button>
            <button type="submit" className="add">Ajouter</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EventFormModal;